import { NEW_PRICING_ENABLED } from './featureFlags'

export interface TrialCopy {
  /** Headline-style label for trial summary, e.g. button captions. */
  shortLabel: string
  /** One-line strapline for hero subtitles or CTAs. */
  oneLine: string
  /** Three-bullet list rendered under hero CTAs. */
  bullets: [string, string, string]
}

const NEW_TRIAL_COPY: TrialCopy = {
  shortLabel: 'Card-secured 7-day trial',
  oneLine: 'Card-secured 7-day trial · Auto-converts on day 7 · Cancel anytime',
  bullets: [
    'Card-secured 7-day trial',
    'Auto-converts to paid on day 7 · Cancel anytime before then',
    '14-day cooling-off · Monthly rolling · No exit fees',
  ],
}

const LEGACY_TRIAL_COPY: TrialCopy = {
  shortLabel: '7-day free trial',
  oneLine: '7-day free trial · No credit card · Cancel anytime',
  bullets: [
    '7-day free trial',
    'No credit card required',
    'Monthly rolling · Cancel anytime',
  ],
}

export const trialCopy: TrialCopy = NEW_PRICING_ENABLED ? NEW_TRIAL_COPY : LEGACY_TRIAL_COPY
